import ActionTypes from "../constants/ActionTypes";

// let user = JSON.parse(localStorage.getItem('user'));
// const initialState = user ? { isFetching: false, user } : {};
const initialState = {
   isFetching: false,
   user: {},
   message: "",
   isNotifyMessage: false,
   data: { isVerifyOtp: false },
};
export default (state = initialState, action) => {
   switch (action.type) {
      case ActionTypes.LOGIN_REQUEST:
         return {
            ...state,
            isFetching: true,
            user: action.user,
            message: action.message,
         };
      case ActionTypes.LOGIN_SUCCESS:
         return {
            isFetching: false,
            user: action.user,
            message: action.message,
            data: { isVerifyOtp: state.data?.isVerifyOtp || false },
         };
      case ActionTypes.LOGIN_FAILURE:
         return {
            ...state,
            isFetching: false,
            message: action.message,
            isNotifyMessage: false,
         };
      case ActionTypes.LOGOUT:
         return {};

      case ActionTypes.RECEIVE_OTP:
         return {
            ...state,
            isFetching: false,
            isNotifyMessage: action.isNotifyMessage,
            message: action.message,
            data: action.data,
         };

      case ActionTypes.RESEND_OTP:
         return {
            isFetching: true,
            user: action.user,
            data: action.data,
         };

      case ActionTypes.VERIFIED_OTP_FAILED:
         return {
            ...state,
            isFetching: false,
            message: action.message,
            isNotifyMessage: action.isNotifyMessage,
            data: action.data,
         };

      case ActionTypes.LOGIN_UPDATE_MESSAGE:
         return {
            ...state,
            message: action.message,
            isNotifyMessage: action.isNotifyMessage,
         };

      case ActionTypes.SET_FETCH_STATE:
         return {
            ...state,
            isFetching: action.isFetching,
            message: action.message,
            isNotifyMessage: action.isNotifyMessage,
         };
      default:
         return state;
   }
};
